/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Duration_WordsInputs */

const en_us2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`duration length time minutes`)
};

const pt_br2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`duracao tempo minutos`)
};

const es_419_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`duracion tiempo minutos`)
};

const pt_pt2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`duracao tempo minutos`)
};

const fr_fr2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`duree temps minutes longueur`)
};

const de_de2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dauer länge zeit minuten`)
};

const it_it2_search_field_duration_words = /** @type {(inputs: Search_Field_Duration_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`durata tempo minuti`)
};

/**
* | output |
* | --- |
* | "duration length time minutes" |
*
* @param {Search_Field_Duration_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_duration_words = /** @type {((inputs?: Search_Field_Duration_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Duration_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_duration_words(inputs)
	if (locale === "es-419") return es_419_search_field_duration_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_duration_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_duration_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_duration_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_duration_words(inputs)
	return en_us2_search_field_duration_words(inputs)
});
export { search_field_duration_words as "search.field_duration_words" }